export enum Workflows {
  CSD = "CSD",
  NO_CSD_PLUS_ACA = "NoCSDPlusACA",
  ACA_EXTERNAL_ONLY = "ACAExternalOnly"
}
